import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payment-sucess',
  templateUrl: './payment-sucess.component.html',
  styleUrls: ['./payment-sucess.component.scss']
})
export class PaymentSucessComponent implements OnInit {

  constructor(
    private router : Router,
  ) { }

  ngOnInit(): void {
    sessionStorage.removeItem('orders-data')
    setTimeout(() => {
      this.router.navigate(['/horizontal/food-menu']);
    }, 3000);
  }

}
